<template>
  <searches :child-id="id" />
</template>

<script>
  import Searches from '@/components/Child/ChildTabs/TabSearchList/Searches.vue'

  export default {
    props: {
      id: {
        required: true
      }
    },

    components: {
      Searches
    }
  }
</script>
